module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  AWS_S3_BUCKET_NAME: process.env.REACT_APP_AWS_S3_BUCKET_NAME,
  AWS_S3_REGION: process.env.REACT_APP_AWS_S3_REGION,
  FE_URL: process.env.REACT_APP_FE_URL,
  FROALA_LICENSE_KEY: process.env.REACT_APP_FROALA_LICENSE_KEY,
  LIVECHAT_LICENSE: process.env.REACT_APP_LIVECHAT_LICENSE,
};
